import { all, fork, put, takeLatest } from "redux-saga/effects";
import actions from "../actions";
import CONSTANTS from "../CONSTANTS";

const questionaryUrl = "/services/rcp/profile/questionary/";
export function* getQuestionStatus() {
  yield takeLatest(CONSTANTS.GET_MAIN_QUESTION_STATUS, function* () {
    try {
      yield put(actions.setQuestionStatus());

      const url = questionaryUrl + "status";
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      const data = res.data;

      yield put(actions.setQuestionStatus(data));
    } catch (e) {
      yield put(actions.setQuestionStatus());
      console.error(e);
    }
  });
}

export default function* questionarySaga() {
  yield all([fork(getQuestionStatus)]);
}
